/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fillInSounds } from '@/utils/sounds';
import Word from '../Word';
import './style.less';

// 被拖动div
let dv = null;
// transition执行次数
let transitionNum = 0;

class FillIn extends Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    url: PropTypes.string,
    changeBtn: PropTypes.func,
    retryBtn: PropTypes.func,
    audioPlay: PropTypes.func,
    soundsUrl: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      fillInData: null,
      wordData: null,
      show: true,
    };
    this.wordRef = React.createRef();
  }

  componentDidMount() {
    const { exercisesData, url } = this.props;
    this.init(exercisesData, url);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url && this.init(nextProps.exercisesData, nextProps.url);
  }

  init = (exercisesData, url) => {
    const match = exercisesData.root[0].tasks[0].task[0].matches[0].match;
    const target = exercisesData.root[0].tasks[0].task[0].targets[0].target;
    const Data = [];
    const wordData = [];
    target.forEach((item, index) => {
      Data.push({
        txt: item._attr.text._value,
        audio: item._attr.audio ? `${url}OM/${item._attr.audio._value}.ogg` : '',
        val: match[index]._attr.text._value,
        playClass: '',
      });
    });
    match.forEach((item) => {
      wordData.push({
        val: item._attr.text._value,
        audio: item._attr.audio ? `${url}OM/${item._attr.audio._value}.ogg` : '',
      });
    });
    this.arrRandom(wordData);
    this.setState({
      fillInData: Data,
      wordData,
    });
  }

  handleCheck = () => {
    const questionList = document.querySelectorAll('.fill-in-txt');
    let isRight = true;
    questionList.forEach((item) => {
      item.dataset.val !== item.childNodes[1].childNodes[0].childNodes[1].innerText
        && (isRight = false);
    });
    if (isRight) {
      questionList.forEach((item) => {
        const textnode = document.createTextNode(item.dataset.val);
        item.replaceChild(textnode, item.childNodes[1]);
      });
      this.handlePlay(`${this.props.soundsUrl}${fillInSounds.allRight}`, -1);
      this.props.finished();
      this.props.retryBtn(true);
    } else {
      this.props.changeBtn(true);
      this.handleWrong();
    }
  }

  handleRetry = () => {
    this.props.changeBtn(true);
    this.props.retryBtn(false);
    this.setState({ show: false }, () => {
      this.setState({ show: true });
    });
  }

  handleWordMouseup = (word) => {
    dv = word;
    const x = dv.offsetLeft + (dv.clientWidth / 2);
    const y = dv.offsetTop + (dv.clientHeight / 2);
    let mouseup = false;
    // 可视窗口上下左右距离
    dv.parentNode.className !== 'word-dv' && document.querySelectorAll('.blank').forEach((item) => {
      const dvWrapper = item;
      const conT = item.offsetTop - 60 - document.querySelector('.question-wrapper').scrollTop;
      const conB = conT + item.clientHeight + 60;
      const conL = item.offsetLeft - 30;
      const conR = conL + item.clientWidth + 60;
      // 在单词摆放区域添加否则回到原来位置 单词中心点是否在空白内
      // console.log('y=', y, conT, conB);
      if ((x >= conL && x <= conR && y >= conT && y <= conB) && !mouseup) {
        mouseup = true;
        dv.className = 'word';
        item.appendChild(dv);
        dvWrapper.className = 'word-dv';
        dv.addEventListener('touchstart', this.startDrag);
        dv.addEventListener('mousedown', this.startDrag);
        document.querySelectorAll('.blank').length < 1
          && this.props.changeBtn(false);
      }
    });
    dv.className = dv.className.replace('down', '');
    dv.style.left = `${dv.offsetLeft}px`;
    dv.style.top = `${dv.offsetTop}px`;
  }

  startDrag = (e) => {
    e.currentTarget.className = 'word';
  }

  handleWrong = () => {
    // 掉下来
    document.querySelectorAll('.word-dv').forEach((item, index) => {
      const wordShadow = document.getElementById(`wordShadow${item.childNodes[0].id.replace(/[^0-9]/ig, '')}`);
      const word = document.getElementById(item.childNodes[0].id);
      const dvWrapper = item;
      dvWrapper.className = 'blank';
      word.className = 'word position animation';
      word.style.left = `${wordShadow.offsetLeft}px`;
      word.style.top = `${wordShadow.offsetTop}px`;
      index === document.querySelectorAll('.word-dv').length - 1
        && word.addEventListener('transitionend', this.handleTransitionend);
    });
  }

  handleTransitionend = () => {
    // 放大缩小
    transitionNum += 1;
    transitionNum === 2 && document.querySelectorAll('.blank').forEach((item) => {
      const word = document.getElementById(item.childNodes[0].id);
      word.className = 'word position animation1';
      transitionNum = 0;
      word.removeEventListener('transitionend', this.handleTransitionend);
      document.querySelectorAll('.word-dv').length === 0
        && word.addEventListener('animationend', this.handleAnimationend);
    });
  }

  handleAnimationend = () => {
    this.handleRetry();
  }

  handleParseInt = val => parseInt(val.replace('px', ''), 10);

  arrRandom = (wordData) => {
    const arr = wordData;
    arr.sort(() => Math.random() - 0.5);
  }

  handlePlay = (src, index) => {
    this.props.audioPlay(src, { type: 'exercise', index });
  }

  handleSounds = () => {
    const { soundsUrl } = this.props;
    this.handlePlay(`${soundsUrl}${fillInSounds.handle}`, -1);
  }

  readWords = (src) => {
    this.handlePlay(src, -1);
  }

  audioPlay = (data) => {
    const { fillInData } = this.state;
    fillInData.forEach((item, i) => {
      console.log(item);
      fillInData[i].playClass = '';
    });
    data.index !== -1 && (fillInData[data.index].playClass = 'playing');
    this.setState({ fillInData });
  }

  audioEnd = () => {
    const { fillInData } = this.state;
    fillInData && fillInData.forEach((item, i) => {
      console.log(item);
      fillInData[i].playClass = '';
    });
    fillInData && this.setState({ fillInData });
  }

  render = () => {
    const { fillInData, wordData, show } = this.state;
    return (
      <div className="fill-in-container">
        <div className="question-wrapper">
          {
            show && fillInData && fillInData.map((item, index) => (
              <div className="question" key={`question${index + 1}`}>
                {item.audio && <div className={`fill-in-play ${item.playClass}`} onClick={() => this.handlePlay(item.audio, index)} />}
                <div className="fill-in-txt" data-val={item.val}>
                  {item.txt.substr(0, item.txt.indexOf('[]'))}
                  <div className="blank" />
                  {item.txt.substr(item.txt.indexOf('[]')
                  + 2, item.txt.length - 1)}
                </div>
              </div>
            ))
          }
        </div>
        <div className="word-wrapper">
          {
            show && wordData && wordData.map((item, index) => (
              <div className="word-shadow" id={`wordShadow${index}`} key={`word-shadow${index + 1}`}>
                <Word
                  index={index}
                  item={item}
                  mouseup={this.handleWordMouseup}
                  ref={this.wordRef}
                  handleSounds={this.handleSounds}
                  readWords={this.readWords}
                />
              </div>
            ))
          }
        </div>
      </div>
    );
  };
}

export default FillIn;
